import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import 'rxjs/add/operator/map';
import { ConfigParams, AMOTimingsData, AMOTimingsResponseData, AMOHolidayList, AMOTimingList, AMOTimingResponse } from 'sharedweb/app.interface';
import { applicationUrls } from 'sharedweb/helpers/urls';

@Injectable({
    providedIn: 'root'
})

export class ConfigParamsService {

    private _configParamsRequest: Promise<ConfigParams>;
    private _amoDataRequest: Promise<AMOTimingsData>;
    public amoData: AMOTimingsData;
    public configParams: ConfigParams;
    public uAlgoProducts : string[];

    constructor(
        private _http: HttpClient,
    ) {
    }
    getConfigParams(): Promise<ConfigParams> {
        if (this.configParams === undefined) {
            if (this._configParamsRequest) {
                return this._configParamsRequest;
            } else {
                const url = applicationUrls.getConfigParams;
                this._configParamsRequest = new Promise((resolve, reject) => {
                    this._http.get<ConfigParams>(url)
                        .subscribe((res)  => {
                            if (res) {
                                this.configParams = res;
                                this.uAlgoProducts = res.uAlgo;
                            } else {
                                this.configParams = null;
                            }
                            resolve(res);
                        }, (err) => {
                            reject(err);
                        });
                });
                return this._configParamsRequest;
            }
        } else {
            return new Promise(resolve => resolve(this.configParams));
        }
    }

    getAMOData(): Promise<any> {
        if (this.amoData === undefined) {
            if (this._amoDataRequest) {
                return this._amoDataRequest;
            } else {
                const url = applicationUrls.getAMOData;
                this._amoDataRequest = new Promise((resolve, reject) => {
                    this._http.get<any>(url).subscribe((res: AMOTimingsResponseData) => {
                        this.amoData = this.updateAMOData(res);
                        resolve(this.amoData);
                    }, (err) => {
                        reject(err);
                    });
                });
                return this._amoDataRequest;
            }
        } else {
            return new Promise(resolve => resolve(this.amoData));
        }
    }
    
    updateAMOData(amoResponseData: AMOTimingsResponseData): AMOTimingsData {
       let amoData: AMOTimingsData = {
        amo_timings: {},
        holiday_list: {}
       };
       if (amoResponseData?.amo_timings) {
        amoData.amo_timings = this.updateAMOTimings(amoResponseData.amo_timings);
       }

       if (amoResponseData?.holiday_list) {
        amoData.holiday_list = this.updateAMOHolidayList(amoResponseData);
       }

       return amoData;
    }

    updateAMOTimings(amo_timings_response: AMOTimingResponse[]): AMOTimingList {
        let amo_timings: AMOTimingList = {};

        amo_timings_response.forEach((timing: AMOTimingResponse) => {
            const key = `${timing.asset_type}_${timing.exchange_id}`;
            const sessionType = timing.session_type.toString();
            
            // Initialize the AMOTiming object for this key if it doesn't exist
            if (!amo_timings[key]) {
                amo_timings[key] = {};
            }
            
            // Initialize the session type array if it doesn't exist
            if (!amo_timings[key][sessionType]) {
                amo_timings[key][sessionType] = [];
            }
            
            // Add the timing object to the session type array
            amo_timings[key][sessionType].push({
                start_time: timing.start_time,
                end_time: timing.end_time
            });
        });

        return amo_timings;
    }


    updateAMOHolidayList(amoResponseData: AMOTimingsResponseData): AMOHolidayList {
        let holiday_list: AMOHolidayList = {};

        amoResponseData.holiday_list.forEach(holiday => {
            // Create the key in format "assetType_exchangeId"
            const key = `${holiday.asset_type}_${holiday.exchange_id}`;
            const sessionType = holiday.session_type;

            // Parse the holiday date to extract year, month, and date
            const holidayDate = new Date(holiday.holiday_date);
            const year = holidayDate.getFullYear().toString();
            const month = (holidayDate.getMonth() + 1).toString().padStart(2, '0');
            const date = holidayDate.getDate().toString().padStart(2, '0');

            // Initialize the holiday object for this key if it doesn't exist
            if (!holiday_list[key]) {
                holiday_list[key] = {};
            }

            // Initialize the year object if it doesn't exist
            if (!holiday_list[key][year]) {
                holiday_list[key][year] = {};
            }

            // Initialize the month object if it doesn't exist
            if (!holiday_list[key][year][month]) {
                holiday_list[key][year][month] = {};
            }

            // Initialize the date object if it doesn't exist
            if (!holiday_list[key][year][month][date]) {
                holiday_list[key][year][month][date] = sessionType;
            }
        });

        return holiday_list;
    }

    updateLiveAMOTimings(amo_timings: AMOTimingResponse[]) {
        if (amo_timings) {
            this.amoData.amo_timings = this.updateAMOTimings(amo_timings);
        }
    }
}

